import { buildTranslate } from 'locales'
import Nav from 'react-bootstrap-five/Nav'

const t = buildTranslate('games')

interface GamesTabsProps {
  activeTab: 'collection' | 'activity'
  onTabChange: (tab: 'collection' | 'activity') => void
}

const GamesTabs = ({ activeTab, onTabChange }: GamesTabsProps) => {
  const handleSelect = (selectedKey: string | null) => {
    if (selectedKey === 'collection' || selectedKey === 'activity') {
      onTabChange(selectedKey)
    }
  }

  return (
    <Nav
      className="nav-tabs"
      role="tablist"
      aria-label="Games navigation"
      activeKey={activeTab}
      onSelect={handleSelect}
    >
      <Nav.Item>
        <Nav.Link
          eventKey="collection"
          role="tab"
          aria-controls="games-tabs-collection-panel"
        >
          {t('enabled.tabs.collection')}
        </Nav.Link>
      </Nav.Item>
      {/* Activity tab disabled - no content yet */}
      {/*
      <Nav.Item>
        <Nav.Link
          eventKey="activity"
          role="tab"
          aria-controls="games-tabs-activity-panel"
        >
          {t('enabled.tabs.activity')}
        </Nav.Link>
      </Nav.Item>
      */}
    </Nav>
  )
}

export default GamesTabs
